import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { CustomFontProperties } from 'common/utils/fontsUtils'

export function getOfferPriceFontProperties(entity: OfferPriceInterface) {
  const fontProperties = entity.nameFontFamily
    ? [
        {
          fontFamily: entity.nameFontFamily,
          fontStyle: entity.nameFontStyle,
          fontWeight: entity.nameFontWeight,
        },
      ]
    : []

  if (entity.mobileNameFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileNameFontFamily,
      fontStyle: entity.mobileNameFontStyle,
      fontWeight: entity.mobileNameFontWeight,
    })
  }

  if (entity.descriptionFontFamily) {
    fontProperties.push({
      fontFamily: entity.descriptionFontFamily,
      fontStyle: entity.descriptionFontStyle,
      fontWeight: entity.descriptionFontWeight,
    })
  }

  if (entity.mobileDescriptionFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileDescriptionFontFamily,
      fontStyle: entity.mobileDescriptionFontStyle,
      fontWeight: entity.mobileDescriptionFontWeight,
    })
  }

  if (entity.amountFontFamily) {
    fontProperties.push({
      fontFamily: entity.amountFontFamily,
      fontStyle: entity.amountFontStyle,
      fontWeight: entity.amountFontWeight,
    })
  }

  if (entity.mobileAmountFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileAmountFontFamily,
      fontStyle: entity.mobileAmountFontStyle,
      fontWeight: entity.mobileAmountFontWeight,
    })
  }

  return fontProperties
}

export function getOfferPriceCustomFontProperties(entity: OfferPriceInterface) {
  const fontProperties: CustomFontProperties[] = []
  if (entity.nameFontFamily && entity.nameFontFileId) {
    fontProperties.push({
      fontFamily: entity.nameFontFamily,
      fontFileId: entity.nameFontFileId,
    })
  }

  if (entity.mobileNameFontFamily && entity.mobileNameFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileNameFontFamily,
      fontFileId: entity.mobileNameFontFileId,
    })
  }

  if (entity.descriptionFontFamily && entity.descriptionFontFileId) {
    fontProperties.push({
      fontFamily: entity.descriptionFontFamily,
      fontFileId: entity.descriptionFontFileId,
    })
  }

  if (
    entity.mobileDescriptionFontFamily &&
    entity.mobileDescriptionFontFileId
  ) {
    fontProperties.push({
      fontFamily: entity.mobileDescriptionFontFamily,
      fontFileId: entity.mobileDescriptionFontFileId,
    })
  }

  if (entity.amountFontFamily && entity.amountFontFileId) {
    fontProperties.push({
      fontFamily: entity.amountFontFamily,
      fontFileId: entity.amountFontFileId,
    })
  }

  if (entity.mobileAmountFontFamily && entity.mobileAmountFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileAmountFontFamily,
      fontFileId: entity.mobileAmountFontFileId,
    })
  }

  return fontProperties
}
